// This component houses
// 	- Option to switch dataset, L
// 	- List of tables for selected dataset
// 	- Tablle for sample records
//  This component is called from DataViewer.tsx with pbId as prop

//  This component is called from DataViewer.tsx with pbId as prop

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
import { AnyAction } from 'redux';
import LoadingPopover from '../CommonFunctions/PopOverComponents/LoadingPopover';
import './dataViewerBottom.css';
import DisplayTable from './DisplayTable';
import {
  setSelectedDsInTile,
  setSelectedTableInTile,
  resetChartProperties,
} from '../../redux/ChartPoperties/ChartPropertiesActions';
import {
  actionsToAddTile,
  resetAllStates,
  setSelectedDataSetList,
  setTablesForSelectedDataSets,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import {
  ChartPropChartAxes,
  IndChartPropProperties,
} from '../../redux/ChartPoperties/ChartPropertiesInterfaces';
import Logger from '../../Logger';
import { setSelectedDatasetForDynamicMeasure } from '../../redux/DynamicMeasures/DynamicMeasuresActions';
import RichTreeViewControl from '../Controls/RichTreeViewControl';
import {
  checkIfMissingColumn,
  ConvertListOfListToDataConnectionRichTreeViewList,
  flattenList,
  updateSampleRecords,
} from '../CommonFunctions/CommonFunctions';
import {
  addChartFilterGroupName,
  addChartFilterTabTileName,
  setDatasetGroupList,
  updateChartFilterSelectedGroups,
} from '../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import SavedCalculationsHolder from '../Calculations/SavedCalculationHolder/SavedCalculationsHolder';

import { resetPlayBookData } from '../../redux/PlayBook/PlayBookActions';
import { resetChartControls } from '../../redux/ChartPoperties/ChartControlsActions';
import Box from '@mui/material/Box';
import { palette } from '../..';
import { useDispatch } from 'react-redux';
import SnackBar from '../SnackBar';
import { resetCurrentCalculationSession } from '../../redux/Calculations/CalculationsActions';
import { AcceptRejectDialog } from '../CommonFunctions/DialogComponents';
import {
  getAllDataSets,
  getColumnTypes,
  getDataSetDetail,
  getTableData,
  getTables,
} from '../../api';
import { DatasetAndTableList } from './Dataset_TableList';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  ICalculationInfo,
  ICurrentCalculationSession,
} from '../../redux/Calculations/CurrentCalculationSessionInterface';
import { AlertColor } from '@mui/material';
import { IGetDatasetResponse } from '../../api/types/dataset';
import {
  IndTabRilePropsTablesForSelectedDatasets,
  TabTilPropsSelectedDatasetList,
} from '../../redux/TabTile/TabTilePropsInterfaces';
import { DatasetItem } from '../../redux/_Dataset/types';

interface IDataset {
  id: string;
  label: string;
  workSpaceId?: string;
  fileType: 'dataset';
  vendor: string;
  isExtract?: boolean;
  isFlatFileData?: boolean;
}

const DataViewerBottom = ({ pbId }: { pbId: string }) => {
  const { tabTileProps, chartProps, tabState, chartFilterGroup, calculations, chartControls } =
    useSelector((state: RootState) => ({
      tabTileProps: state.tabTileProps,
      chartProps: state.chartProperties,
      tabState: state.tabState,
      chartFilterGroup: state.chartFilterGroup,
      calculations: state.calculations,
      chartControls: state.chartControls,
    }));

  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var selectedChartProp: IndChartPropProperties = chartProps.properties[propKey];
  const [showLoader, setShowLoader] = useState(false);
  const dispatch = useDispatch();
  const thunkDispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();

  const [openAlert, setOpenAlert] = useState(true);
  const [QueryErrorMessage, setQueryErrorMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('success');

  const [showTreeView, setShowTreeView] = useState(false);
  const [dataSetTree, setDataSetTree] = useState<Array<Object>>([]);
  const [selectedDataSet, setSelectedDataSet] = useState<IDataset>({
    id: '',
    label: '',
    workSpaceId: '',
    fileType: 'dataset',
    vendor: '',
  });

  const [isDatasetSwitchDialogOpen, setIsDatasetSwitchDialogOpen] = useState(false);
  const [pendingDatasetValue, setPendingDatasetValue] = useState<string | null>(null);

  const chartData = chartControls.properties[propKey].chartData;

  /**
   * 0th index will always be filter thats how state and dispatches are desgined
   */
  const chartFilter = chartProps.properties[propKey].chartAxes[0].fields;
  const currentCalculationSession = calculations?.properties[propKey]?.currentCalculationSession;
  let sampleRecordsStored = sessionStorage.getItem('sampleRecords');
  let sampleRecords = sampleRecordsStored ? JSON.parse(sampleRecordsStored) : {};

  const showAlert = (message: string, severity: AlertColor) => {
    setQueryErrorMessage(message);
    setSeverity(severity);
    setOpenAlert(true);
    setTimeout(() => {
      setOpenAlert(false);
    }, 3000);
  };

  const savedCalculations = useMemo(() => {
    // Filter logic inside useMemo's body
    return calculations.savedCalculations.filter(
      (calculation) => calculation.datasetId === selectedDataSet?.id,
    );
  }, [calculations?.savedCalculations, selectedDataSet?.id]);
  const [dataLoadedToStorage, setDataLoadedToStorage] = useState(false);
  const location = useLocation();
  const state = location.state;
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');
  const playbookId = searchParams.get('playbookId');

  const getNewGroupName = (numOfGroups: number): string => {
    let isUnique = true;
    let newName = 'Filter Group ' + numOfGroups;
    Object.keys(chartFilterGroup.groups).forEach((grp) => {
      if (chartFilterGroup.groups[grp].name === newName) {
        isUnique = false;
        return;
      }
    });
    if (!isUnique) {
      return getNewGroupName(numOfGroups + 1);
    } else {
      return newName;
    }
  };

  const handleProceedButtonClick = (id: string) => {
    let tree = JSON.parse(JSON.stringify(dataSetTree));

    let flatList = flattenList(tree) as IDataset[];

    let found = flatList.find((item) => item.id === id);

    if (found) {
      setSelectedDataSet(found);

      setShowTreeView(false);
    } else {
      showAlert('Please select a DataSet.', 'error');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const ds = tabTileProps.selectedDataSetList.find(
        (ds: TabTilPropsSelectedDatasetList) => ds.id === selectedDataSet.id,
      );
      if (selectedDataSet.id && !ds) {
        setLoading(true);
        let response = await getDataSetDetail(
          selectedDataSet.id,
          selectedDataSet.workSpaceId || state?.parentId || workspaceId,
        );
        if (response.isError) {
          showAlert(response.message, 'error');
          setLoading(false);
          return;
        }
        let dataSetResponse = response.data;
        let dataSet = {
          connectionId: dataSetResponse!.connectionId,
          datasetName: selectedDataSet.label,
          id: selectedDataSet.id,
          vendor: dataSetResponse.vendor,
          isFlatFileData: dataSetResponse!.isFlatFileData ?? false,
          workSpaceId: selectedDataSet.workSpaceId,
          isExtract: dataSetResponse.isExtract ?? false,
        };

        dispatch(setSelectedDataSetList(dataSet));
        dispatch(setSelectedDatasetForDynamicMeasure(dataSet));

        dispatch(
          setTablesForSelectedDataSets({ [dataSet.id]: dataSetResponse!.dataSchema.tables }),
        );
        /*  PRS 13Nov2024 */
        dispatch(setSelectedDsInTile(propKey, dataSet));
        const table = dataSetResponse!.dataSchema.tables[0];
        handleTableChange(
          table,
          dataSetResponse?.isExtract || dataSetResponse?.isFlatFileData || false,
          dataSetResponse!.id,
          savedCalculations?.length > 0
            ? savedCalculations
                ?.filter(
                  (calculation) => !calculation?.isAggregated && calculation?.tableId === table.id,
                )
                ?.map((calculation) => calculation?.calculationInfo)
            : [],
          dataSetResponse!.connectionId,
        );

        const groupList = chartFilterGroup.datasetGroupsList?.[dataSet.id];
        const isGroupMissing = !Array.isArray(groupList) || groupList.length === 0;
        if (!chartProps.properties[propKey].selectedDs.id || isGroupMissing) {
          dispatch(addChartFilterTabTileName(dataSet.id, propKey));

          let numOfGroups = 0;
          if (chartFilterGroup.groups && Object.keys(chartFilterGroup.groups).length > 0) {
            numOfGroups = Object.keys(chartFilterGroup.groups).length;
          }

          let newGroupName = getNewGroupName(numOfGroups + 1);
          let groupId = dataSet.id + '_' + newGroupName + new Date().getMilliseconds();

          dispatch(addChartFilterGroupName(dataSet.id, groupId, newGroupName));
          dispatch(updateChartFilterSelectedGroups(propKey, groupId));
        } else dispatch(setDatasetGroupList(dataSet.id));
        setLoading(false);
        setShowLoader(true);
        setTimeout(() => {
          setShowLoader(false);
        }, 3000);
      } else if (selectedDataSet.id) {
        if (!!chartProps.properties[propKey]?.selectedDs && ds) {
          dispatch(setSelectedDsInTile(propKey, ds));
          const tablesForDs = tabTileProps.tablesForSelectedDataSets[selectedDataSet.id];
          const table = tablesForDs[0];
          handleTableChange(
            table,
            selectedDataSet.isExtract || selectedDataSet.isFlatFileData || false,
            selectedDataSet.id,
            savedCalculations?.length > 0
              ? savedCalculations
                  ?.filter(
                    (calculation) =>
                      !calculation?.isAggregated && calculation?.tableId === table.id,
                  )
                  ?.map((calculation) => calculation?.calculationInfo)
              : [],
            ds.connectionId,
          );
        }
        setShowLoader(true);
        setTimeout(() => {
          setShowLoader(false);
        }, 3000);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDataSet]);

  const fetchDataset = async () => {
    try {
      const allDataSetResponse = await getAllDataSets();
      if (allDataSetResponse.isError) {
        showAlert(allDataSetResponse.message, 'error');
      } else {
        setDataSetTree(
          ConvertListOfListToDataConnectionRichTreeViewList(allDataSetResponse.data, 'dataset'),
        );

        if (!pbId && !selectedChartProp.selectedDs?.id) {
          setShowTreeView(true);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (!pbId && !selectedChartProp.selectedDs?.id) {
      dispatch(resetChartProperties());
      dispatch(resetPlayBookData());
      dispatch(resetChartControls());
      sessionStorage.removeItem('sampleRecords');
    }

    fetchDataset();
  }, [pbId]);

  const [open, setOpen] = useState<boolean>(false);
  const [selectedDataset, setSelectedDataset] = useState<DatasetItem>({
    id: '',
    connectionId: '',
    datasetName: '',
    isFlatFileData: false,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const [openChangeDatasetDlg, setOpenChangeDatasetDlg] = useState<boolean>(false);
  const [addNewOrChooseExistingDS, setAddNewOrChooseExistingDS] = useState<string>('');

  // When a new dataset is added to the tile for work,
  // set it in SelectedDataSet of tabTileProps
  useEffect(() => {
    setSelectedDataSet(chartProps.properties[propKey].selectedDs);
    Logger('info', 'Selected Dataset', selectedDataset);
    if (selectedDataset.id !== '') {
      var isAlready = tabTileProps.selectedDataSetList.filter(
        (ds: TabTilPropsSelectedDatasetList) => ds.id === selectedDataset.id,
      );
      if (isAlready.length > 0) {
        window.alert('Dataset already in selected list');
      } else {
        const fetchData = async () => {
          dispatch(setSelectedDataSetList(selectedDataset));
          dispatch(setSelectedDatasetForDynamicMeasure(selectedDataset));

          var datasetFromServer = await getTables(selectedDataset.id);
          if (datasetFromServer.isError) {
            showAlert(datasetFromServer.message, 'error');
            return;
          }
          let datasetFromServerData = datasetFromServer.data;
          dispatch(
            setTablesForSelectedDataSets({
              [selectedDataset.id]: datasetFromServerData!!.dataSchema.tables,
            }),
          );
          dispatch(setSelectedDsInTile(propKey, selectedDataset));
          setOpen(false);
        };

        fetchData();
      }
    }
  }, [selectedDataset]);

  // When a Dataset is selected, make sure the tables for that dataset is present in store.
  // If not, get it from server and save in store

  useEffect(() => {
    const fetchData = async () => {
      if (
        tabTileProps?.tablesForSelectedDataSets?.[selectedChartProp?.selectedDs?.id] === undefined
      ) {
        // setLoading(true);
        var tablesFromServer = await getTables(selectedChartProp.selectedDs?.id);
        if (tablesFromServer.isError) {
          showAlert(tablesFromServer.message, 'error');
          return;
        }
        let tablesFromServerData = tablesFromServer.data;
        dispatch(
          setTablesForSelectedDataSets({
            [selectedDataset.id]: tablesFromServerData?.dataSchema?.tables,
          }),
        );
        // setLoading(false);
      }
    };

    if (selectedChartProp.selectedDs?.id) {
      fetchData();
    }
  }, [selectedChartProp.selectedDs]);

  useEffect(() => {
    if (!state && !workspaceId && !playbookId) {
      navigate('/');
    }
  }, [state, workspaceId, playbookId, navigate]);
  if (!state && !workspaceId && !playbookId) {
    return null;
  }

  /*When a table selected in dataset is changed,
  check if this table's sample records are already present
  if yes,display them. If no, get the table records and save in store*/

  const handleTableChange = async (
    table:
      | IGetDatasetResponse['dataSchema']['tables'][0]
      | IndTabRilePropsTablesForSelectedDatasets,
    isExtract?: boolean,
    dsUid?: string,
    savedNonAggregatedCalculations?: ICalculationInfo[],
    dcConnId?: string,
    _propKey?: string,
  ) => {
    // console.log('hanldeTableChange');
    // console.log(savedNonAggregatedCalculations);
    if (!savedNonAggregatedCalculations) {
      console.log('Something went wrong');
      return;
    }

    if (table.flatFileId) {
    }
    if (table.id !== selectedChartProp.selectedTable) {
      dispatch(
        setSelectedTableInTile(_propKey ?? propKey, {
          [dsUid ?? selectedChartProp.selectedDs.id]: table.id,
        }),
      );

      if (sampleRecords?.[dsUid ?? selectedChartProp.selectedDs?.id]?.[table.id]) return;
      else {
        const extract =
          isExtract ??
          (selectedChartProp.selectedDs?.isExtract || selectedChartProp.selectedDs?.isFlatFileData);
        setLoading(true);
        setDataLoadedToStorage(false);
        let dc_uid = dcConnId ?? selectedChartProp.selectedDs?.connectionId;
        let id = dsUid || selectedChartProp.selectedDs?.id;

        // console.log(savedNonAggregatedCalculations);
        // console.log(table);

        let validCalculations = savedNonAggregatedCalculations;
        // checkIfMissingColumn is async and returns a Promise<boolean>, so await it for each field
        let getErrorCalculations: ICalculationInfo[] = [];
        for (const cal of savedNonAggregatedCalculations) {
          const fieldKeys = Object.keys(cal.fields);
          let hasMissing = false;
          for (const fieldKey of fieldKeys) {
            try {
              const res = await checkIfMissingColumn(
                cal.fields[fieldKey],
                selectedDataSet,
                tabTileProps.tablesForSelectedDataSets[selectedDataSet.id],
              );
              // console.log(cal.fields[fieldKey]);
              if (res.isMissing) {
                hasMissing = true;
                break;
              }
            } catch (err) {
              hasMissing = true;
              break;
            }
          }
          if (hasMissing) getErrorCalculations.push(cal);
        }

        validCalculations = validCalculations.filter(
          (cal: any) =>
            !getErrorCalculations.some(
              (el: ICalculationInfo) => el.displayFieldName === cal.displayFieldName,
            ),
        );
        let tableRecordsResponse = await getTableData(
          extract,
          dc_uid,
          table,
          id,
          selectedChartProp.selectedDs.workSpaceId || state?.parentId || workspaceId,
          validCalculations,
          true,
        );

        let recordsTypeResponse = await getColumnTypes(
          extract,
          dc_uid,
          id,
          table,
          selectedChartProp.selectedDs.workSpaceId || state?.parentId || workspaceId,
          validCalculations,
          true,
        );

        let filterCalculations: any = [];
        if (getErrorCalculations.length > 0) {
          filterCalculations = getErrorCalculations.map((cal: ICalculationInfo) => {
            const calc = savedCalculations.find((c) => c.name === cal.calculatedFieldName);
            if (calc) {
              return {
                columnName: calc.name,
                dataType: calc.datatype,
              };
            }
          });
          const existingCols = new Set(
            (recordsTypeResponse.data || []).map((item: any) => item.columnName),
          );

          const filteredData = (filterCalculations || []).filter(
            (el: any) => !existingCols.has(el.columnName),
          );

          recordsTypeResponse.data = [...recordsTypeResponse.data, ...filteredData];
          tableRecordsResponse.data;

          if (Array.isArray(filteredData) && tableRecordsResponse?.data) {
            for (const row of tableRecordsResponse.data) {
              for (const col of filteredData) {
                if (row[col.columnName] === undefined) {
                  row[col.columnName] = '';
                }
              }
            }
          }
        }
        if (!tableRecordsResponse || tableRecordsResponse.isError || !tableRecordsResponse.data) {
          showAlert(tableRecordsResponse.message || 'Error in fetching Table Data sample', 'error');
          return;
        }
        if (recordsTypeResponse.isError || !recordsTypeResponse.data) {
          showAlert(recordsTypeResponse.message, 'error');
          return;
        }
        let tableRecords = tableRecordsResponse.data;

        let recordsType = recordsTypeResponse.data;

        sessionStorage.setItem(
          'sampleRecords',
          JSON.stringify(
            updateSampleRecords(sampleRecords, id, table.id, tableRecords, recordsType),
          ),
        );
        setDataLoadedToStorage(true);
        setLoading(false);
      }
    }
  };

  /* when the dataset itself is changed,
  if there are no added fields in dropzone, allow the change.
  else, open a new tile with the selected dataset*/

  const handleDataSetChange = (value: string) => {
    const currentSession = calculations.properties[propKey]?.currentCalculationSession;

    if (currentSession && value !== (selectedChartProp.selectedDs?.id ?? selectedDataSet.id)) {
      setPendingDatasetValue(value);
      setIsDatasetSwitchDialogOpen(true);
      return;
    }
    proceedWithDatasetChange(value);
  };

  /**
   * this function adds extra measure field into chart measure axis fields.
   */
  const getAllAxes = () => {
    const chartAxes = chartProps.properties[propKey].chartAxes;
    const extraMeasureAxis =
      chartControls.properties[propKey].formatOptions?.tooltipFormats?.extraMeasureField[0];

    if (extraMeasureAxis.fields.length === 0) {
      return chartAxes;
    }
    const tempChartAxes = JSON.parse(JSON.stringify(chartAxes));
    const measureAxisIndex = tempChartAxes.findIndex(
      (axis: any) => axis.name === 'Measure' || axis.name === 'X Axis' || axis.name === 'Y Axis',
    );

    tempChartAxes[measureAxisIndex].fields.push(...extraMeasureAxis.fields);

    return tempChartAxes;
  };

  const proceedWithDatasetChange = (value: string) => {
    let axes = getAllAxes();

    setAddNewOrChooseExistingDS(value);
    if (value === 'addNewDataset') {
      var count = 0;
      axes.forEach((ax: ChartPropChartAxes) => {
        if (ax.fields.length > 0) {
          count = count + 1;
        }
      });

      if (count > 0) {
        setOpenChangeDatasetDlg(true);
      } else {
        //setOpen(true); ////TODO:
        setShowTreeView(true);
      }
    } else {
      var count = 0;
      axes.forEach((ax: ChartPropChartAxes) => {
        if (ax.fields.length > 0) {
          count = count + 1;
        }
      });

      if (count > 0) {
        setOpenChangeDatasetDlg(true);
      } else {
        var dsObj = tabTileProps.selectedDataSetList.filter(
          (ds: TabTilPropsSelectedDatasetList) => ds.id === value,
        )[0];
        dispatch(setSelectedDsInTile(propKey, dsObj));
        handleTableChange(
          tabTileProps.tablesForSelectedDataSets[dsObj.id][0],
          dsObj.isExtract || dsObj.isFlatFileData,
          dsObj.id,
          savedCalculations?.length > 0
            ? savedCalculations
                ?.filter(
                  (calculation) =>
                    !calculation?.isAggregated &&
                    calculation?.tableId === tabTileProps.tablesForSelectedDataSets[dsObj.id][0].id,
                )
                ?.map((calculation) => calculation?.calculationInfo)
            : [],
          dsObj.connectionId,
        );
        setShowLoader(true);
        setTimeout(() => {
          setShowLoader(false);
        }, 3000);
      }
    }
  };

  const onChangeOrAddDataset = () => {
    let tabObj = tabState.tabs[tabTileProps.selectedTabId];

    const datasetToUse = pendingDatasetValue || addNewOrChooseExistingDS;

    thunkDispatch(
      actionsToAddTile({
        tabId: tabObj.tabId,
        nextTileId: tabObj.nextTileId,
        table: tabTileProps.selectedTable, //tabTileProps.selectedTable,
        /**
         * do not modify below 2 objects
         * based on selectedDs and selectedTable
         * we are determining some actions in useEffect
         * of this component
         */
        selectedDs: chartProps.properties[propKey].selectedDs,
        selectedTablesInDs: chartProps.properties[propKey].selectedTable,
        fromTab: false,
      }),
    );
    let selectedDatasetID = chartProps.properties[propKey]?.selectedDs?.id;
    if (!selectedDatasetID) {
      navigate('/');
      thunkDispatch(resetAllStates());
      return;
    }
    const nextPropKey = `${tabObj.tabId}.${tabObj.nextTileId}`;
    const groupList = chartFilterGroup.datasetGroupsList?.[selectedDatasetID];
    const isGroupMissing = !Array.isArray(groupList) || groupList.length === 0;
    dispatch(addChartFilterTabTileName(selectedDatasetID, nextPropKey));
    if (isGroupMissing) {
      let numOfGroups = 0;
      if (chartFilterGroup.groups && Object.keys(chartFilterGroup.groups).length > 0) {
        numOfGroups = Object.keys(chartFilterGroup.groups).length;
      }

      let newGroupName = getNewGroupName(numOfGroups + 1);
      let groupId = selectedDatasetID + '_' + newGroupName + new Date().getMilliseconds();
      dispatch(addChartFilterGroupName(selectedDatasetID, groupId, newGroupName));
      dispatch(updateChartFilterSelectedGroups(nextPropKey, groupId));
    } else {
      if (chartFilterGroup.groups && Object.keys(chartFilterGroup.groups).length > 0) {
        dispatch(updateChartFilterSelectedGroups(nextPropKey, groupList[0]));
      }
    }
    if (openChangeDatasetDlg) setOpenChangeDatasetDlg(false);
    if (isDatasetSwitchDialogOpen) setIsDatasetSwitchDialogOpen(false);
    if (datasetToUse === 'addNewDataset') {
      /*  PRS 13Nov2024 */
      setShowTreeView(true);
      //setOpen(true);
    } else {
      var dsObj = tabTileProps.selectedDataSetList.filter(
        (ds: TabTilPropsSelectedDatasetList) => ds.id === datasetToUse,
      )[0];
      dispatch(setSelectedDsInTile(`${tabObj.tabId}.${tabObj.nextTileId}`, dsObj));
      const nextPropKey = `${tabObj.tabId}.${tabObj.nextTileId}`;

      dispatch(addChartFilterTabTileName(dsObj.id, nextPropKey));
      if (chartFilterGroup.groups && Object.keys(chartFilterGroup.groups).length > 0) {
        dispatch(
          updateChartFilterSelectedGroups(nextPropKey, Object.keys(chartFilterGroup.groups)[0]),
        );
      }
      const tablesForDs = tabTileProps.tablesForSelectedDataSets[dsObj.id];
      const table = tablesForDs[0];
      handleTableChange(
        table,
        dsObj.isExtract || dsObj.isFlatFileData,
        dsObj.id,
        savedCalculations?.length > 0
          ? savedCalculations
              ?.filter(
                (calculation) => !calculation?.isAggregated && calculation?.tableId === table.id,
              )
              ?.map((calculation) => calculation?.calculationInfo)
          : [],
        dsObj.connectionId,
        nextPropKey,
      );
    }
  };

  return (
    <React.Fragment>
      {QueryErrorMessage.length > 0 ? (
        <NotificationDialog
          onCloseAlert={() => {
            setOpenAlert(false);
            setQueryErrorMessage('');
          }}
          severity={severity}
          testMessage={QueryErrorMessage}
          openAlert={openAlert}
        />
      ) : null}
      {showTreeView ? (
        <RichTreeViewControl
          currentWorkspace={state?.parentId || workspaceId}
          list={dataSetTree}
          title={'Select a DataSet'}
          showInPopup={showTreeView}
          showControls={true}
          handleCloseButtonClick={() => {
            const anyTileHasData = Object.values(chartProps.properties).some(
              (prop) => (prop as IndChartPropProperties).selectedDs?.id,
            );
            if (anyTileHasData) {
              setShowTreeView(false);
            } else {
              setShowTreeView(false);
              navigate('/');
              thunkDispatch(resetAllStates());
            }
          }}
          handleProceedButtonClick={handleProceedButtonClick}
        ></RichTreeViewControl>
      ) : null}

      {chartProps.properties[propKey].chartType === 'richText' ? null : (
        <div className="dataViewerBottom">
          <DatasetAndTableList
            selectedDataSetId={selectedDataSet.id}
            savedCalculations={savedCalculations}
            handleDataSetChange={handleDataSetChange}
            handleTableChange={handleTableChange}
            open={open}
            setOpen={setOpen}
            setSelectedDataset={setSelectedDataset}
          />

          {selectedChartProp.selectedTable?.[selectedChartProp.selectedDs.id] && !loading ? (
            <Box
              className="tileTableView"
              sx={{ '&::-webkit-scrollbar': { width: '4px', height: '4px' } }}
            >
              <DisplayTable
                recordLoaded={dataLoadedToStorage}
                dsId={selectedChartProp.selectedDs?.id}
                table={selectedChartProp.selectedTable[selectedChartProp.selectedDs?.id]}
              />
            </Box>
          ) : (
            <div
              className="axisInfo"
              style={{
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: palette.primary.contrastText,
              }}
            >
              {null}
            </div>
          )}
          {loading ? <LoadingPopover /> : null}
          {(!currentCalculationSession || currentCalculationSession === null) && (
            <AcceptRejectDialog
              open={openChangeDatasetDlg}
              closeFunction={() => setOpenChangeDatasetDlg(false)}
              heading="CHANGE IN DATASET DETECTED"
              messages={[
                {
                  text: 'Do you want to open the changed dataset in a new tile?',
                },
              ]}
              acceptFunction={() => {
                setOpenChangeDatasetDlg(false);
                onChangeOrAddDataset();
              }}
              rejectFunction={() => setOpenChangeDatasetDlg(false)}
              acceptText="Yes"
              rejectText="No"
            />
          )}
          {/* <div> */}
          <SnackBar
            message={`Now showing the tables and formula measures belong to dataset ${
              selectedChartProp.selectedDs?.datasetName ?? selectedDataSet.label
            }`}
            show={showLoader}
            dir={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            onClose={() => {}}
          />
          <SavedCalculationsHolder propKey={propKey} />
          {/* </div> */}
        </div>
      )}

      {isDatasetSwitchDialogOpen &&
        (!chartData && !chartFilter ? (
          <AcceptRejectDialog
            open={isDatasetSwitchDialogOpen}
            closeFunction={() => setIsDatasetSwitchDialogOpen(false)}
            heading="Switch Dataset"
            messages={[
              {
                text: 'There are unsaved changes in the formula builder. If you switch the dataset, unsaved changes will be discarded. Do you want to switch?',
              },
            ]}
            acceptFunction={() => {
              setIsDatasetSwitchDialogOpen(false);
              dispatch(resetCurrentCalculationSession(propKey));
              if (pendingDatasetValue !== null) {
                proceedWithDatasetChange(pendingDatasetValue);
              }
              setPendingDatasetValue(null);
            }}
            rejectFunction={() => setIsDatasetSwitchDialogOpen(false)}
            acceptText="Switch"
            rejectText="Cancel"
          />
        ) : (
          <AcceptRejectDialog
            open={isDatasetSwitchDialogOpen}
            closeFunction={() => setIsDatasetSwitchDialogOpen(false)}
            heading="Switch Dataset"
            messages={[
              {
                text: 'There are unsaved changes in the formula builder. If you switch the dataset, unsaved changes will be discarded. Do you want to switch?',
              },
            ]}
            acceptFunction={() => {
              if (pendingDatasetValue !== null) setAddNewOrChooseExistingDS(pendingDatasetValue);
              onChangeOrAddDataset();
              setPendingDatasetValue(null);
            }}
            rejectFunction={() => setIsDatasetSwitchDialogOpen(false)}
            acceptText="Switch"
            rejectText="Cancel"
          />
        ))}
    </React.Fragment>
  );
};

export default DataViewerBottom;
